import { QUERY_KEYS_SERVICE_AGREEMENTS } from 'api/query-keys';
import { serviceAgreementsService } from 'ogp/services';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { useQuery } from 'react-query';

export const useGetServiceAgreementsForCompany = () => {
  const queryFn = async () => await serviceAgreementsService.getServiceAgreementsForCompany();

  return useQuery<ServiceAgreementsResponse[], Error, ServiceAgreementsResponse[]>(
    QUERY_KEYS_SERVICE_AGREEMENTS.serviceAgreementsForCompany(),
    queryFn
  );
};
